import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { useAuth } from '@pilot-hub/auth'
import { AppShell, NavIcons, NAV_ICON_CLASS, UserMenuIcons, useFeedbackUngelesen, EinsatzWahl, StatusBar, StaleBanner, EinsatzHinweis } from '@pilot-hub/ui'
import type { NavItem, UserMenuEntry } from '@pilot-hub/ui'
import { PhasenSteuerung } from './PhasenSteuerung'
import { isFeatureEnabled } from '@pilot-hub/config'


/** Führungs-Modul auf der gemeinsamen AppShell (packages/ui/src/components/shell). */
export function Layout() {
  const { user, logout } = useAuth()
  const location = useLocation()
  const feedbackUngelesen = useFeedbackUngelesen()

  const navItems: NavItem[] = [
    { path: '/verwaltung', label: 'Dashboard', icon: <NavIcons.dashboard className={NAV_ICON_CLASS} /> },
    { path: '/einsaetze', label: 'Einsätze', icon: <NavIcons.missions className={NAV_ICON_CLASS} />, show: isFeatureEnabled('fuehrung', 'einsatzuebersicht') },
    { path: '/kraefte-management', label: 'Kräfte Management', icon: <NavIcons.resources className={NAV_ICON_CLASS} /> },
    { path: '/taktische-karte', label: 'Taktische Karte', icon: <NavIcons.map className={NAV_ICON_CLASS} /> },
    { path: '/live-video', label: 'Live-Video', icon: <NavIcons.streams className={NAV_ICON_CLASS} /> },
    { path: '/medien', label: 'Medien', icon: <NavIcons.media className={NAV_ICON_CLASS} /> },
    { path: '/risikobewertung', label: 'Risikobewertung', icon: <NavIcons.risk className={NAV_ICON_CLASS} /> },
  ]

  const userMenu: UserMenuEntry[] = useMemo(() => [
    { id: 'settings', label: 'Einstellungen', icon: UserMenuIcons.settings, to: '/settings' },
    {
      id: 'feedback', label: 'Feedback & Roadmap', icon: UserMenuIcons.feedback, to: '/feedback',
      state: { von: location.pathname + location.search }, badge: feedbackUngelesen,
    },
    { type: 'heading', label: 'Handbuch' },
    { id: 'hb-kompakt', label: 'Handbuch kompakt', icon: UserMenuIcons.handbookShort, href: '/handbuch/anwenderhandbuch-fuehrung-kompakt.pdf' },
    { id: 'hb-lang', label: 'Handbuch ausführlich', icon: UserMenuIcons.handbookLong, href: '/handbuch/anwenderhandbuch-fuehrung-ausfuehrlich.pdf' },
    { type: 'separator' },
    { id: 'logout', label: 'Abmelden', icon: UserMenuIcons.logout, danger: true, onSelect: () => logout() },
  ], [location.pathname, location.search, feedbackUngelesen, logout])

  return (
    <AppShell
      moduleName="Führungskräfte-Modul"
      moduleSubtitle="ASB Drohnenstaffel"
      logoSrc="/logo.png"
      navItems={navItems}
      dockPaths={['/verwaltung', '/taktische-karte', '/live-video', '/kraefte-management']}
      dockLabels={{ '/verwaltung': 'Lage', '/taktische-karte': 'Karte', '/live-video': 'Livebild', '/kraefte-management': 'Kräfte' }}
      pageTitles={{ '/einsaetze/': 'Einsatz' }}
      user={{ name: `${user?.vorname ?? ''} ${user?.nachname ?? ''}`.trim() || 'Benutzer', username: user?.benutzername, subtitle: (user?.rollen?.[0] as string | undefined), dot: feedbackUngelesen > 0 }}
      userMenu={userMenu}
      einsatzWahl={<EinsatzWahl />}
      headerRight={<PhasenSteuerung />}
      status={<StatusBar />}
      banner={<><StaleBanner /><EinsatzHinweis /></>}
    />
  )
}
